export default {
    baseStyle: {
        imageWrapper: {
            position: 'relative'
        },
        redBadgeStyle: {
            position: 'absolute',
            top: 0,
            left: 0,
            marginLeft: 2,
            marginTop: 2,
            fontSize: '10px',
            variant: 'solid',
            colorScheme: 'red'
        },
        blueBadgeStyle: {
            position: 'absolute',
            top: 0,
            left: 0,
            marginLeft: 2,
            marginTop: 2,
            fontSize: '10px',
            variant: 'solid',
            colorScheme: 'blue'
        }
    }
}
